export default "__VITE_ASSET__54989308__"